import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import OrgListCard from "./OrgListCard";
import Loader from "./Loader";
import ProfileView from "./ProfileView";

function SearchResult({ searchRequest }) {
  const [loading, setLoading] = useState(true);
  const [showResults, setShowResults] = useState(false);
  const [orgList, setOrgList] = useState([]);
const [selectedOrg, setSelectedOrg] = useState(null);
  useEffect(() => {
   setShowResults(false);
   setSelectedOrg(null);

    const fetchCompanyAddresses = async () => {
      try {
        setLoading(true);

     const res = await fetch(
  `${process.env.REACT_APP_API_BASE_URL}/company-address?company_name=${encodeURIComponent(searchRequest.company_name)}`
);

        const data = await res.json();

        // Format if needed
        const formatted = (data.addresses || []).map((item, index) => ({
          id: item.entityId || `org-${index}`,
          name: item.companyName,
          address: item.address,
        }));

        setOrgList(formatted);
      } catch (error) {
        console.error("API Error:", error);
        setOrgList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyAddresses();
  }, [searchRequest]);

   if (loading) {
    return (
      <Box sx={{  width: '80%' }}>
        <Loader />
      </Box>
    );
  }

  return (
    <AnimatePresence mode="wait">
      {!showResults ? (
        <motion.div
          key="orglist"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
      <OrgListCard
  orgs={orgList}
  handleClick={(org) => {
    setSelectedOrg(org);
    setShowResults(true);
  }}
/>
        </motion.div>
      ) : (
        <motion.div
          key="results"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -30 }}
          transition={{ duration: 0.3 }}
        >
          <Box
            sx={{
            
              width: "100%",
              overflowX: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: 4,
              py: 5,
              pt: 8,
              boxSizing: "border-box",
              position: "relative",
            }}
          >
            <IconButton
              onClick={() => setShowResults(false)}
              sx={{
                position: "absolute",
                top: 0,
                left: 16,
                color: "inherit",
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(4px)",
                borderRadius: "50%",
                "&:hover": {
                  background: "rgba(255,255,255,0.2)",
                },
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            <ProfileView org={selectedOrg} />

          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default SearchResult;
